import { Stack, Typography } from "@mui/material";
import { IForgotPasswordSuccessModal } from "../../../../interfaces/globalComponents/authComponents/forgotPassword/IForgotPasswordSuccessModal";
import { DefaultModal } from "../../modals/material/DefaultModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { PrimaryButton } from "../../buttons/material/primaryButton/PrimaryButton";
import Link from "next/link";

export const ForgotPasswordSuccessModal = ({
  open,
  onClose,
}: IForgotPasswordSuccessModal) => {
  const theme = useSelector((state: RootState) => state.theme);
  return (
    <DefaultModal open={open} onClose={onClose}>
      <Stack
        className="
      lg:min-w-[477px] px-[26px] py-[46px]
      lg:p-[46px] flex flex-col items-center sm:w-[400px] sm:mx-auto justify-center space-y-[16px]"
      >
        <Stack className="space-y-[10px]">
          <Typography
            sx={{
              color: theme.componentColors.surface.surfaceFull,
            }}
            className="text-[22px] font-medium"
          >
            Password reset
          </Typography>
          <Typography
            sx={{
              color: theme.componentColors.surface.onSurface,
            }}
          >
            Instructions for your password reset have been sent to your email.
          </Typography>
        </Stack>
        <Link href="/login" onClick={onClose} className="w-full">
          <PrimaryButton className="w-full" title="Login" />
        </Link>
      </Stack>
    </DefaultModal>
  );
};
